module.exports = __webpack_public_path__ + "img/undraw_Online_payments_re_y8f2.efcc9a48.png";